import { Components, Theme } from '@mui/material/styles';
import scssVariables from '@styles/variables.module.scss';

export const MuiCard: Components<Theme>['MuiCard'] = {
  defaultProps: {
    elevation: 0,
  },
  styleOverrides: {
    root: {
      borderRadius: 'var(--border-radius-x-large)',
      border: `1px solid ${scssVariables.ColorFog20}`,
    },
  },
};

export const MuiCardContent: Components<Theme>['MuiCardContent'] = {
  styleOverrides: {
    root: {
      padding: 'var(--spacing-unit-3)',

      '&:last-child': {
        paddingBottom: 'var(--spacing-unit-3)',
      },
    },
  },
};
